export default __webpack_public_path__ + "static/media/nav_detail_img_11.d7d9d1af.jpg";